var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"service-notice"},_vm._l(((_vm.notices)),function(item,index){return _c('mpx-view',{key:item.index,on:{"tap":function($event){return _vm.goServicePage(item.url)}}},[_vm._v(_vm._s(item.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }